import css from 'styled-jsx/css';
import Theme, { colors } from '../../themes';

const { borderRadius } = Theme.global;

export default css`
  .placeholder {
    display: block;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    background: #fff;
    color: ${colors.grayDark};
    border-radius: ${borderRadius};
    padding: 7px 7px 11px 160px;
    overflow: hidden;
    margin: 0 8px 8px;
    min-height: 160px;
    position: relative;
    text-decoration: none;
  }

  .placeholder span {
    background: ${colors.grayExtraLight};
    display: block;
    height: 15px;
    margin: 5px 0 10px;
    border-radius: ${borderRadius};
  }

  .placeholder span.s2 {
    width: 90%;
  }

  .placeholder span.s3 {
    width: 80%;
  }

  .placeholder .img {
    overflow: hidden;
    position: absolute;
    left: 5px;
    top: 5px;
    bottom: 5px;
    width: 140px;
    margin: 0;
    height: auto;
  }

  :global(.rtl) .placeholder {
    padding: 7px 160px 11px 7px;
  }

  :global(.rtl) .placeholder .img {
    left: auto;
    right: 5px;
  }

  .placeholder .cover {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0.001) 45%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0.001) 55%
    );
    background-size: 300% 100%;
    animation: Gradient 1.2s ease infinite;
    position: absolute;
    top: -10%;
    height: 110%;
    left: -15%;
    width: 115%;
    transform: skewX(-10deg);
  }

  .placeholder.p1 .cover {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
  }

  @keyframes Gradient {
    0% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }

  @media (max-width: 320px) {
    .placeholder {
      padding-left: 130px;
    }

    :global(.rtl) .placeholder {
      padding-right: 130px;
    }

    .placeholder .img {
      width: 110px;
    }
  }
`;



// WEBPACK FOOTER //
// ./app/common/Placeholders/placeholdersStyles.js